import { useEffect, useState } from "react";

import { useAppContext } from "@examspark/common-app";

export const useUsername = () => {
  const [context] = useAppContext();
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (context.user && context.user.firstName && context.user.lastName) {
      setUsername(`${context.user.firstName} ${context.user.lastName}`);
    }
  }, [context.user]);

  return username;
};
